import { useContext } from "react";
import { BrokerSubscriptionTypesEnum } from "dash-common";
import { ViewerContext } from "dash-ui";

import { hasPaidAccess, needsPaymentUpdate } from "../lib/paid-access";

/**
 * The viewer's paid access. Same rule as dash-ui's `isSubscriptionActive`
 * (demo brokers always pass), widened to payments Stripe is still retrying.
 */
export function usePaidAccess() {
  const { subscription, broker } = useContext(ViewerContext);
  const isDemo = broker?.subscriptionType === BrokerSubscriptionTypesEnum.DEMO;

  return {
    hasPaidAccess: isDemo || hasPaidAccess(subscription?.status),
    needsPaymentUpdate: !isDemo && needsPaymentUpdate(subscription?.status),
  };
}
